<template>
    <rkm-modal
        ref="Modal"
        title="Sugestão de dose"
    >
        <rkm-table
            :fields="fields"
            :items="doses"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="handleSelectDose(item)"
                    color="primary"
                    small
                    title="Selecionar dose"
                >
                    <rkm-icon icon="check" />
                </rkm-button>
            </template>
        </rkm-table>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                @click="cancel"
                color="secondary"
            >
                Cancelar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    data: () => ({
        doses: [],
        fields: [
            { key: 'doseAnteriorNome', label: 'Dose anterior aplicada' },
            { key: 'nome', label: 'Próxima dose' },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ]
    }),
    methods: {
        open(doses) {
            this.doses = doses

            this.$refs.Modal.show()
        },
        handleSelectDose(dose) {
            this.$emit('select-dose', dose)
            this.$refs.Modal.hide()
        }
    }
}
</script>